import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import WhyADoctor from "@/components/site/WhyADoctor";
import Resources from "@/components/site/Resources";
import Celebrities from "@/components/site/Celebrities";
import Stats from "@/components/site/Stats";
import Science from "@/components/site/Science";
import Product from "@/components/site/Product";
import BoxShowcase from "@/components/site/BoxShowcase";
import Testimonials from "@/components/site/Testimonials";
import VideoBackground from "@/components/site/VideoBackground";
import GlobalPatchStream from "@/components/three/GlobalPatchStream";

export default function LandingPage() {
  return (
    <div className="relative min-h-screen text-white">
      <VideoBackground />
      <GlobalPatchStream count={2} cycle={8} />
      <Header />
      <main className="relative z-10">
        <Hero />
        <WhyADoctor />
        <Resources />
        <Celebrities />
        <Stats />
        <Science />
        <Product />
        <BoxShowcase />
        <Testimonials />
      </main>
    </div>
  );
}
